import { updateConfigSettings } from "../../../actions/siteadmin/ConfigSettings/updateConfigSettings";
import { demoRestriction } from "../../../helpers/DemoRestriction/demoRestriction";

const submit = async (values, dispatch) => {
    const isRestrict = await dispatch(demoRestriction({}));
    if (isRestrict) return;
    try {
        dispatch(updateConfigSettings(values, true));
    } catch (error) {
    }
}

export default submit